















import Vue from 'vue'
import OneComment from '@/components/comments/OneComment.vue'
export default Vue.extend({
  data() {
    return {
      contentText: "",
      comments: []
    }
  },
  components: {
    OneComment
  },
  props: {
    replies: {
      type: Array
    },

    instructor: {
      type: Object
    },

    commentPermission: {
      type: String
    },
    pendoPayload: {
      type: Object
    }
  },
  async mounted() {
    this.comments = this.replies
  },

  methods: {
    findCommentIndexById(id: string) {
      return this.comments.findIndex(elem => String(elem.id) === String(id))
    },
    updateStateChildComment(params) {
      const indexOfChild = this.findCommentIndexById(params.id)
      this.comments[indexOfChild].content = params.content
    }
  },

  watch: {
    "replies": {
      handler() {
        this.comments = this.replies
      }
    }
  }
})
